<div class="page-header">
  <div class="header-start">
    <h3 class="title">List Of Users</h3>
  </div>
  <div class="header-end">
    <div class="form-ng-select" *ngIf="false">
      <ng-select class="ng-select-toolbar" name="userList" [virtualScroll]="true" [multiple]="true" [items]="userListData"
      placeholder="Search Users" [(ngModel)]="userSelected" (search)="makeChoice($event)" bindLabel="username"
      [closeOnSelect]="true" (change)="onUserSelect($event)" (clear)="clearUserOptions()" [clearSearchOnAdd]="true">
      <ng-template ng-option-tmp let-item="item" let-item$="item$">
        <ng-container *ngIf="item$.selected else emptyCheck"><i class="far fa-check-square"></i>
        </ng-container>
        <ng-template #emptyCheck><i class="far fa-square"></i></ng-template>
        &nbsp;{{item.username}}
      </ng-template>
    </ng-select>

    <ng-select class="ng-select-toolbar" name="customerList" [items]="customerListData" placeholder="Search Customers"
      [(ngModel)]="customerSelected" bindLabel="customerName" [closeOnSelect]="true" (change)="onCustomerSelect($event)"
      (clear)="clearCustomerOptions()" (keydown)="onKeyDown($event)">
    </ng-select>
    </div>

    <button resourceName="USER" permission="EDIT" mat-raised-button color="primary" permissions
      (click)="addUserModal()">
      <i class="fas fa-plus mr-2"></i> Add&nbsp;User
    </button>

  </div>
</div>



<div class="mb-3" permissions resourceName="USER" permission="READ">
  <app-users-list *ngIf="!loading" [isCustomer]="isCustomer" [tableData]="tableData" [tableConfig]="tableConfig">
  </app-users-list>
  <spinner [id]="'user-list-data'" [show]='loading'></spinner>
</div>